// extracted by mini-css-extract-plugin
module.exports = {"mainComponent":"loader_mainComponent__1qoc_"};